/**
 * Onthoudt het laatst-bezochte bord (incl. filters) zodat de sidebar-klik
 * "Borden" terugbrengt naar waar je was. Zelfde patroon als btw-last-url.js.
 */
const KEY = "boards:lastUrl";
const DEFAULT_URL = "/panel/admin/borden";
const PREFIX = "/panel/admin/borden";

export const saveBoardLastUrl = (pathname, search) => {
  if (typeof window === "undefined") return;
  if (!pathname.startsWith(PREFIX)) return;
  try {
    localStorage.setItem(KEY, `${pathname}${search ?? ""}`);
    window.dispatchEvent(new Event("boards:lastUrl"));
  } catch (_e) {
    // storage uit of vol: stil overslaan
  }
};

export const loadBoardLastUrl = () => {
  if (typeof window === "undefined") return DEFAULT_URL;
  try {
    const v = localStorage.getItem(KEY);
    if (v && v.startsWith(PREFIX)) return v;
  } catch (_e) {
    // fallthrough
  }
  return DEFAULT_URL;
};
